import './Cart.css'
import Image1 from '../images/cart.jpeg'
import { useSelector } from 'react-redux'
import CheckoutProducts from '../Components/Checkout'
import { Link } from 'react-router-dom'



export default function Cart() {
    let basket = useSelector(state => state.basket);
    console.log(basket);
    let productCount = basket.length;
    let checkoutProductDetails = basket.map(item => <CheckoutProducts id={item.id} prdName={item.prdName} image={item.img} price={item.price} review={item.review} buttonCart={item.buttonCart} />);
    console.log(checkoutProductDetails)

   

    return (
        <div className='cart'>
            <div className={productCount > 0 ? "cart_off" : "cart_on"}>
                <div className='cart__home'>
                    <div className='cart__list'>
                        <div className='cart__image'>
                            <img src={Image1} />
                        </div>
                        <div className='cart__title'>
                            <span className='title'>Your Amazon Cart is empty</span><br></br>
                            <span><a href='#'>See recommendations</a></span>
                        </div>
                    </div>

                </div>
            </div>
            <div className='cart__details'>
                <span className='cart_details_title'>Your Items : {productCount}</span><br></br>
                <div className={productCount > 0 ? "cart_off" : "cart_on"}>
                <span className='cart__items'>No items to buy</span>
                </div>
                <Link to="/payement"><button className="button">Payement</button></Link>
                <div>
                    {checkoutProductDetails}
                </div>
            </div>

        </div>
    );
}